import { inject } from '@angular/core';
import { RedirectCommand, ResolveFn, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { firstValueFrom, of, switchMap } from 'rxjs';

import { UserSettings } from '@models';
import { TranslateService } from '@ngx-translate/core';
import { ToastService, UserBeanService } from '@services';
import { AppState } from '@store';

export const userBeanResolver: ResolveFn<UserSettings> = () =>
  inject(UserBeanService).getUserBean();

export const userBeanWithPermissionCheckResolver: ResolveFn<
  Nullable<UserSettings>
> = async () => {
  const userBeanService = inject(UserBeanService);
  const store: Store<AppState> = inject(Store);
  const router = inject(Router);

  const userBean: UserSettings = await userBeanService.getUserBean();

  return firstValueFrom(
    store
      .select((state) => state.auth.isLoggedIn)
      .pipe(
        switchMap((isLoggedIn) => {
          if (isLoggedIn) {
            if (userBean.rootUsersPermission > 3) {
              return of(userBean);
            }

            return of(new RedirectCommand(router.parseUrl('/home')));
          }

          return of(null);
        })
      )
  );
};

export const userBeanWithFunctionsCheckResolver: ResolveFn<
  Nullable<UserSettings>
> = async () => {
  const userBeanService = inject(UserBeanService);
  const router = inject(Router);
  const toastService = inject(ToastService);
  const translate = inject(TranslateService);

  const userBean: UserSettings = await userBeanService.getUserBean();
  const isUserAllowed = userBean.functions && userBean.communityPermission >= 3;

  if (!isUserAllowed) {
    toastService.show({
      text: translate.instant('WEB_NOTIFY_RESOURCE_DELETE_ERROR_403'),
      type: 'danger',
    });

    return new RedirectCommand(router.parseUrl('/home'));
  }

  return userBean;
};
